module.exports = __webpack_public_path__ + "img/11.84b31f4d.jpg";